var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Container",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 30C7.5 41.125 15.625 50.375 26.25 52.25L26.3754 52.1497C26.3336 52.1416 26.2918 52.1334 26.25 52.125V36.25H20.625V30H26.25V25C26.25 19.375 29.875 16.25 35 16.25C36.625 16.25 38.375 16.5 40 16.75V22.5H37.125C34.375 22.5 33.75 23.875 33.75 25.625V30H39.75L38.75 36.25H33.75V52.125C33.7082 52.1334 33.6664 52.1416 33.6246 52.1497L33.75 52.25C44.375 50.375 52.5 41.125 52.5 30C52.5 17.625 42.375 7.5 30 7.5C17.625 7.5 7.5 17.625 7.5 30Z",
    fill: "#FBB03B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0c22b93be09e0c350483e0de9cfb84e0.svg";
export { ForwardRef as ReactComponent };